import { $el, $list } from 'src/scripts/utils/utils'
import { SidebarFiltersDesktop, SidebarFiltersMobile } from '.'
import { BaseComponent } from '../../components/base-component'
import { parseHTML, replaceNodeChildren } from '../../utils/dom'

const ELEMENTS = [
  'ShopProducts',
  'ShopProductCount',
  'ShopSortList',
  'ShopActiveFilters',
]
const PRELOADER_SELECTOR = '#ShopProductsOverlay'
const MOBILE_FILTER_SELECTOR = '#SidebarFiltersMobile'
const DESKTOP_FILTER_SELECTOR = '#SidebarFiltersDesktop'

export class ShopComponent extends BaseComponent {
  searchParamsInitial: string
  searchParamsPrev: string
  sortQuery: string = ''
  filterQuery: string = ''

  constructor() {
    super()
    this.searchParamsInitial = window.location.search.slice(1)
    this.searchParamsPrev = this.searchParamsInitial
  }

  mountComponent(): void {
    this.addListener(window, 'popstate', this.handleHistoryChange)
  }

  handleHistoryChange = ({ state: { searchParams } }): void => {
    const newSearchParams = searchParams || this.searchParamsInitial

    if (newSearchParams !== this.searchParamsPrev) {
      this.updateBySearchParams(newSearchParams)
    }
  }

  formatParams(searchParams): string {
    this.searchParamsPrev = searchParams
    return `${
      this.dataset.baseParams ? `${this.dataset.baseParams}` : ''
    }${searchParams}`
  }

  updateBySearchParams(searchParams): void {
    const baseUrl = window.location.pathname
    const params = `${this.formatParams(searchParams ? `${searchParams}` : '')}`
    const url = baseUrl + '?' + params

    this.updateURL(searchParams, url)
    this.updateShop(url)
    this.updateFilters(url)
  }

  async getFromUrl(url) {
    const preloaderElement = $el(PRELOADER_SELECTOR, this)

    preloaderElement.classList.remove('hidden')

    return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        preloaderElement.classList.add('hidden')

        return parseHTML(responseText)
      })
      .catch(() => console.log('Error in shop component'))
  }

  updateShop(url: string): void {
    this.getFromUrl(url).then(html => {
      ELEMENTS.forEach(elementId => {
        const element = $el(`#${elementId}`)
        const newElement = $el(`#${elementId}`, html)

        replaceNodeChildren(element, newElement)
      })
    })
  }

  updateFilters(url: string): void {
    // @ts-expect-error
    const filters: SidebarFiltersDesktop[] | SidebarFiltersMobile[] = $list(
      `${MOBILE_FILTER_SELECTOR}, ${DESKTOP_FILTER_SELECTOR}`,
    )

    filters.forEach(filter => {
      filter.preloader.classList.remove('hidden')
    })

    this.getFromUrl(url).then(html => {
      filters.forEach(filter => {
        filter.updateHTML(html)
        filter.preloader.classList.add('hidden')
      })

      this.emit('filtersUpdated', {})
    })
  }

  updateURL(searchParams, url: string): void {
    history.pushState({ searchParams }, '', url)
  }

  reset(): void {
    this.sortQuery = ''
    this.filterQuery = ''
  }
}
